import styled from 'styled-components';
import { Hideable } from '@prisjakt/ui/hideable';

export const Overlay = styled(Hideable)(props => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: props.theme.bg.overlay,
  zIndex: 99,
}));
